import { applyMiddleware, createStore } from "redux";
import { createReducers } from "./reducers";
import { routerMiddleware } from "connected-react-router";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import rootSaga from "./sagas";
import { createBrowserHistory } from "history";

// Create a history of your choosing (we're using a browser history in this case)
export const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const middlewareEnhancer = applyMiddleware(
  routerMiddleware(history),
  sagaMiddleware
);
const composedEnhancers = composeWithDevTools(middlewareEnhancer);

const store = createStore(createReducers(history), {}, composedEnhancers);

sagaMiddleware.run(rootSaga);

export default store;
